import type {PublicLocale} from './public-locale';

type Exchange = {customer: string | null; head: string; thinking: number};
type Pacing = {customerCharacter: number; replyCharacter: number; minimumRead: number; readCharacter: number};

/** Illustrative public copy only. It never enters an account, tool or payment record. */
const stories: Record<PublicLocale, readonly Exchange[]> = {en: [
  {customer: 'Can you build a website for my ceramics shop?', head: 'Yes. What is the shop called?', thinking: 2600},
  {customer: 'Moss & Clay. I sell handmade mugs for $59.', head: 'I’ll build the shop and add your products.', thinking: 3400},
  {customer: 'Add card and crypto payments, please.', head: 'I’ll set up EightBots Payments and Crypto Payments.', thinking: 3600},
  {customer: 'Can you register mossandclay.com for one year?', head: 'In this example, one year costs $15 (600 credits). Shall I register it?', thinking: 3200},
  {customer: 'Yes. Register it and launch the site.', head: 'Your site is live. Payments, DNS and HTTPS are ready.', thinking: 4500},
  {customer: null, head: 'Hey your first order is in— its $59 sale! Check Earnings in the menu.', thinking: 2800},
], ja: [
  {customer: '手づくりの器を売るお店を、ネットでも開きたいです。', head: 'いいですね。店名と、どんな器を並べたいか教えてください。', thinking: 2800},
  {customer: '「うつわ日和」です。湯のみのペアセットを5,900円で。', head: '器の写真が映える、落ち着いた雰囲気のお店にしましょう。', thinking: 3500},
  {customer: 'カードでも暗号資産でも買えるようにしたいです。', head: 'EightBots PaymentsとCrypto Paymentsで、どちらも使えるようにしますね。', thinking: 4000},
  {customer: 'ドメインもお願いします。utsuwa-biyori.comを1年で。', head: '1年2,400円（600クレジット）です。この内容で登録しますか？', thinking: 3200},
  {customer: 'はい、お願いします。公開までおまかせします。', head: 'お店を公開しました！決済も使えます。DNSやHTTPSの設定も済んでいます。', thinking: 4500},
  {customer: null, head: 'さっそく、初めての注文が入りました！売上は5,900円です。おめでとうございます！詳しくは「収益」メニューで。ここで聞いてもらっても大丈夫ですよ。', thinking: 3800},
]};

const pacing: Record<PublicLocale, Pacing> = {
  en: {customerCharacter: 35, replyCharacter: 32, minimumRead: 3000, readCharacter: 60},
  ja: {customerCharacter: 60, replyCharacter: 55, minimumRead: 4000, readCharacter: 95},
};

export function design2Conversation(locale: PublicLocale) {
  const story = stories[locale];
  const speed = pacing[locale];
  let nextStart = 0;
  const timeline = story.map(exchange => {
    const start = nextStart;
    const sent = start + (exchange.customer === null ? 0 : exchange.customer.length * speed.customerCharacter);
    const reply = sent + exchange.thinking;
    const complete = reply + exchange.head.length * speed.replyCharacter;
    const end = complete + Math.max(speed.minimumRead, exchange.head.length * speed.readCharacter);
    nextStart = end;
    return {start, sent, reply, complete, end};
  });
  return {story, timeline};
}
